import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { toPagination } from './utils';

export const VULNERABILITIES_ATTACK_SURFACE = graphql(`
  query vulnerabilitieSurfaceQuery(
    $pagination: PaginationRequest
    $uuid: String
  ) {
    vulnerabilitiesAttackSurface(
      filters: { submissionUuid: $uuid }
      pagination: $pagination
    ) {
      pageInfo {
        totalResults
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          cve
          cvss
          ipAddresses {
            edges {
              node {
                uuid
                ipv4Address
              }
            }
          }
          software {
            edges {
              node {
                uuid
                product
                vendor
                version
                part
                type
                edition
                update
                language
              }
            }
          }
        }
      }
    }
  }
`);

export function useVulnerabilitiesAttackSurfaceQuery({
  entityUuid,
  pageNumber,
  pageSize,
}: {
  entityUuid: string;
  pageNumber: number;
  pageSize: number;
}) {
  const { loading, error, data } = useQuery(VULNERABILITIES_ATTACK_SURFACE, {
    variables: {
      uuid: entityUuid,
      pagination: toPagination(pageNumber, pageSize),
    },
  });

  //   const info = useMemo(() => {
  //     const entity = getFirstPaginatedNode(data?.entities);
  //     const alias = getFirstPaginatedNode(entity?.aliases);
  //     const insuredName = alias?.name;
  //     const coverages = getPaginatedNodes(entity?.coverages);
  //     const riskReportCoverages = coverages.map((coverage) => {
  //       return {
  //         name: coverage.name ?? 'N/A',
  //         score: coverage.score ?? 0,
  //         minScore: coverage.minScore ?? 0,
  //         maxScore: coverage.maxScore ?? 100,
  //       };
  //     });
  //     return { riskReportCoverages, entity, alias, insuredName, coverages };
  //   }, [data]);

  return {
    error,
    loading,
    data,
  };
}
